import { render } from "./AlignHorizontalRight.vue?vue&type=template&id=2c4c508f"
import script from "./AlignHorizontalRight.vue?vue&type=script&lang=js"
export * from "./AlignHorizontalRight.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/AlignHorizontalRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c4c508f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c4c508f', __exports__)) {
    api.reload('2c4c508f', __exports__)
  }
  
  module.hot.accept("./AlignHorizontalRight.vue?vue&type=template&id=2c4c508f", () => {
    api.rerender('2c4c508f', render)
  })

}


export default __exports__